import WidgetsAngleDownUp from '../src/components/Widgets/AngleDownUp.vue';
import NavigationFrontNavigationHandler from '../src/components/Navigation/FrontNavigationHandler.vue';
import NavigationNavigation from '../src/components/Navigation/Navigation.vue';
import PaginatorSelect from '../src/components/Paginator/Select.vue';
import TagImage from '../src/components/Tag/Image.vue';
import SlideShowSlideShowItem from '../src/components/SlideShow/SlideShowItem.vue';
import GalleryImageGrid from '../src/components/Gallery/ImageGrid.vue';
import TriggersOnOffSwitch from '../src/components/Triggers/OnOffSwitch.vue';
import TriggersRemoveDialogButton from '../src/components/Triggers/RemoveDialogButton.vue';
import TriggersCallRedirect from '../src/components/Triggers/CallRedirect.vue';
import TriggersCallReload from '../src/components/Triggers/CallReload.vue';
import TriggersCallDialogConfirm from '../src/components/Triggers/CallDialogConfirm.vue';
import DialogsTopDialog from '../src/components/Dialogs/TopDialog.vue';
import ModalWrapper from '../src/components/Modal/Wrapper.vue';
import SearchLocalInstantSearch from '../src/components/Search/LocalInstantSearch.vue';
import FormFormButton from '../src/components/Form/FormButton.vue';
import FormTriggerButton from '../src/components/Form/TriggerButton.vue';
import FormFormWrapper from '../src/components/Form/FormWrapper.vue';
import FormSelectRedirect from '../src/components/Form/SelectRedirect.vue';
import InputsTextInput from '../src/components/Form/Inputs/TextInput.vue';
import InputsTextInputWithButton from '../src/components/Form/Inputs/TextInputWithButton.vue';
import InputsHiddenInput from '../src/components/Form/Inputs/HiddenInput.vue';
import InputsEmailInput from '../src/components/Form/Inputs/EmailInput.vue';
import InputsPasswordInput from '../src/components/Form/Inputs/PasswordInput.vue';
import InputsCheckBoxInput from '../src/components/Form/Inputs/CheckBoxInput.vue';
import InputsTextArea from '../src/components/Form/Inputs/TextArea.vue';
import InputsSingleSelect from '../src/components/Form/Inputs/SingleSelect.vue';
import FormMultiPage from '../src/components/Form/MultiPage.vue';
import FormDependableWrapper from '../src/components/Form/DependableWrapper.vue';
import WidgetsCrossReference from '../src/components/Widgets/CrossReference.vue';
import WidgetsFeedWrapper from '../src/components/Widgets/FeedWrapper.vue';
import ComponentsFetchData from '../src/components/FetchData.vue';
import GridGrid from '../src/components/Grid/Grid.vue';

Vue.component('widget-angle-down-up', WidgetsAngleDownUp);

Vue.component('navigation-handler', NavigationFrontNavigationHandler);
Vue.component('navigation', NavigationNavigation);
Vue.component('select-paginator', PaginatorSelect);

/**
 * Image
 */
Vue.component('image-tag', TagImage);
Vue.component('slide-show-item', SlideShowSlideShowItem);
Vue.component('gallery-image-grid', GalleryImageGrid);

/**
 * Utilities
 */
Vue.component('on-off-switch', TriggersOnOffSwitch);
Vue.component('remove-dialog-button', TriggersRemoveDialogButton);
Vue.component('call-redirect', TriggersCallRedirect);
Vue.component('call-reload', TriggersCallReload);
Vue.component('call-dialog-confirm', TriggersCallDialogConfirm);
Vue.component('top-dialog', DialogsTopDialog);

Vue.component('modal-wrapper', ModalWrapper);

/**
 * Search
 */
// Vue.component('instant-search', require('../src/components/Search/AlgoliaSearch'));
Vue.component('local-instant-search', SearchLocalInstantSearch);

/**
 * Form
 */
Vue.component('form-button', FormFormButton);
Vue.component('trigger-button', FormTriggerButton);
Vue.component('form-wrapper', FormFormWrapper);
Vue.component('select-redirect', FormSelectRedirect);

Vue.component('text-input', InputsTextInput);
Vue.component('text-input-with-button', InputsTextInputWithButton);
Vue.component('hidden-input', InputsHiddenInput);
Vue.component('email-input', InputsEmailInput);
Vue.component('password-input', InputsPasswordInput);
Vue.component('checkbox-input', InputsCheckBoxInput);
Vue.component('text-area', InputsTextArea);

Vue.component('single-select', InputsSingleSelect);

Vue.component('multi-page-form', FormMultiPage);
Vue.component('dependable-wrapper', FormDependableWrapper);

/**
 * Widgets
 */
Vue.component('cross-reference', WidgetsCrossReference);
Vue.component('feed-wrapper', WidgetsFeedWrapper);
Vue.component('fetch-data', ComponentsFetchData);

Vue.component('grid', GridGrid);